"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingSource = exports.WidgetTypeEnum = exports.WaitlistStatusEnum = exports.BookingStatusEnum = void 0;
var BookingStatusEnum;
(function (BookingStatusEnum) {
    BookingStatusEnum["CREATED"] = "CREATED";
    BookingStatusEnum["CURRENT"] = "CURRENT";
    BookingStatusEnum["READY"] = "READY";
    BookingStatusEnum["NOTIFIED"] = "NOTIFIED";
    BookingStatusEnum["CHECKED_IN"] = "CHECKED_IN";
    BookingStatusEnum["COMPLETED"] = "COMPLETED";
    BookingStatusEnum["NO_SHOW"] = "NO_SHOW";
    BookingStatusEnum["CANCELLED"] = "CANCELLED";
})(BookingStatusEnum = exports.BookingStatusEnum || (exports.BookingStatusEnum = {}));
var WaitlistStatusEnum;
(function (WaitlistStatusEnum) {
    WaitlistStatusEnum["WAITING"] = "Queued";
    WaitlistStatusEnum["READY"] = "Ready";
    WaitlistStatusEnum["ARRIVED"] = "Seated";
    WaitlistStatusEnum["COMPLETED"] = "Completed";
    WaitlistStatusEnum["NO_SHOW"] = "NoShow";
    WaitlistStatusEnum["CANCELLED"] = "Cancelled";
})(WaitlistStatusEnum = exports.WaitlistStatusEnum || (exports.WaitlistStatusEnum = {}));
var WidgetTypeEnum;
(function (WidgetTypeEnum) {
    WidgetTypeEnum["WAITLIST"] = "WAITLIST";
    WidgetTypeEnum["BOOKING"] = "BOOKING";
})(WidgetTypeEnum = exports.WidgetTypeEnum || (exports.WidgetTypeEnum = {}));
var BookingSource;
(function (BookingSource) {
    BookingSource["Venue"] = "Venue";
    BookingSource["Customer"] = "Customer";
})(BookingSource = exports.BookingSource || (exports.BookingSource = {}));
//# sourceMappingURL=bookings.js.map